var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-block',{attrs:{"placeholder":_vm.placeholder,"options":_vm.getOptions,"value":_vm.formattedValue,"multiple":!!_vm.schema.multiple,"loading":_vm.searchLoading},on:{"input":_vm.setInput,"updateSearch":_vm.updateSearch}})
}
var staticRenderFns = []

export { render, staticRenderFns }